/* @flow */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'JOIN_CLASS_FOR_SETUP_SESSION',
  'REMOVE_FLAGS_FOR_SETUP_SESSION',
]);

// used for origin= params in setup flow
export const origins = {
  CREATED_GROUP: 'created_group',
  SUBSCRIBED: 'subscribed',
  DIRECT: 'direct',
};
export type SetupOrigin = $Values<typeof origins>;
